module.exports = __webpack_public_path__ + "img/img12.f9676068.svg";